import { format } from "date-fns";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import defaultupload from "../../assets/default-upload.svg";
import Warning from "../../assets/Warning.svg";
import CreateCouponInputs from "../../Components/CreateVoucherAndCouponsInputs/CreateCouponInputs";
import Modals from "../../Components/CreateVoucherCouponModal/CreateVoucherCouponModal";
import ProductModal from "../../Components/CreateVoucherCouponModal/ProductModal";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { FroalaTextEditor } from "../../Components/FroalaEditor/FroalaTextEditor";
import { stripHTML } from "../../Components/FroalaEditor/StripHtml";
import Loader from "../../Components/Loader/Loader";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { CreateCouponApi } from "../../Utils/Api/CreateCouponApi";
import { constant } from "../../Utils/Constant";
import { ErrorMessage } from "../../Utils/ErrorMsg/ErrorMsg";
import { getUser, userId } from "../../Utils/LocalStorage";
import Navigation from "../Navigation/Navigation";
import "./EditCoupons.css";
import getCroppedImg from "./cropImage";
import { GetCouponDetailsApi } from "../../Utils/Api/GetCouponDetails";
import { UpdateCouponApi } from "../../Utils/Api/UpdateCouponApi";

const EditCoupon = () => {
  const parameter = useParams();
  const id = parseInt(parameter.id);
  const max_character_count = 1000;
  const [inputtnc, setInputtnc] = useState("");
  const [addtnc, setAddtnc] = useState([]);
  const [tnc, setTnc] = useState([]);
  const [list, setList] = useState([]);

  const [startDat, setStartDat] = useState(null);
  const [endDat, setEndDat] = useState(null);
  const [availableDat, setAvailableDat] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [dat, setDat] = useState({
    coupon_name: "",
    coupon_code: "",
    description: "",
  });

  const [description, setDescription] = useState("");
  const [errorLabelDesc, setErrorLabelDesc] = useState("");
  const [errorLabeltnc, setErrorLabeltnc] = useState("");
  const [errorLabelname, setErrorLabelname] = useState("");
  const [errorLabelcode, setErrorLabelcode] = useState("");
  const [errorLabelquantity, setErrorLabelquantity] = useState("");
  const [errorLabelstart, setErrorLabelstart] = useState("");
  const [errorLabelend, setErrorLabelend] = useState("");
  const [errorLabelAvailableDate, setErrorLabelAvailableDate] = useState("");
  const [errorLabelapi, setErrorLabelapi] = useState("");

  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [isPreviewDisabled, setIsPreviewDisabled] = useState(true);
  const [productModalShow, setProductModalShow] = useState(false);
  const [dataApihandler, setDataApihandler] = useState("");

  const [logoImage, setLogoImage] = useState(null);
  const [fbImage, setFbImage] = useState(null);
  const [errorLogoImage, setErrorLogoImage] = useState("");
  const [isImageChange, setIsImageChange] = useState(0);
  const [isSocialImageChange, setIsSocialImageChange] = useState(0);

  // Status management (draft vs published)
  const [couponStatus, setCouponStatus] = useState("published");

  const uid = parseInt(userId());
  const Bu_data = getUser();
  const navigate = useNavigate();

  const handleLogoImageChange = (newLogo) => {
    setLogoImage(newLogo);
    setIsImageChange(1);

    setIsSocialImageChange((prevIsSocialChanged) => {
      if (!prevIsSocialChanged) {
        setFbImage(null);
      }
      return prevIsSocialChanged;
    });
  };

  // Handler for FB / Social Image updates
  const handleFbImageChange = (newFb) => {
    setFbImage(newFb);
    setIsSocialImageChange(1);
  };

  const getCouponDetails = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const data = { coupon_id: id };
      const res = await GetCouponDetailsApi(data);
      if (res && res.data) {
        const couponData = res.data;

        setDat({
          coupon_name: couponData.coupon_name || "",
          coupon_code: couponData.coupon_code || "",
          description: couponData.coupon_description || "",
        });

        setDescription(couponData.coupon_description || "");

        if (couponData.coupon_start_date) {
          setStartDat(new Date(couponData.coupon_start_date));
        }
        if (couponData.coupon_end_date) {
          setEndDat(new Date(couponData.coupon_end_date));
        }
        if (couponData.coupon_avail_until_date) {
          setAvailableDat(new Date(couponData.coupon_avail_until_date));
        }

        setQuantity(couponData.total_quantity || "");

        if (couponData.coupon_image) {
          setLogoImage(couponData.coupon_image);
        }
        if (couponData.coupon_social_image) {
          setFbImage(couponData.coupon_social_image);
        }

        if (Array.isArray(couponData.coupon_term_condition)) {
          const fetchedTnc = couponData.coupon_term_condition.slice(1);

          setTnc(fetchedTnc);

          setAddtnc((prev) => Array.from(new Set([...fetchedTnc, ...prev])));
        }
      }
    } catch (error) {
      console.error("Error fetching coupon details:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getCouponDetails();
  }, [id]);

  const handleTncApi = async () => {
    const data = {
      api_method: "get",
    };
    const tncList = await CreateCouponApi(data, () => {
      navigate("/");
    });

    if (tncList?.status === 429) {
      setLoading(true);
      toast.error(tncList.message, {
        position: "top-center",
        autoClose: 6000,
        theme: "dark",
      });
    }

    const defaultApiTnc = tncList?.tnc || [];

    const combinedList = Array.from(
      new Set([...defaultApiTnc, ...addtnc, ...tnc]),
    );
    setList(combinedList);
  };

  useEffect(() => {
    handleTncApi();
  }, [addtnc, tnc]);

  const handleCheck = (e, item) => {
    const { checked } = e.target;
    if (checked) {
      setTnc((prev) => [...prev, item]);
    } else {
      setTnc((prev) => prev.filter((t) => t !== item));
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    setInputtnc(event.target.value);
    if (event.target.value.length === 0) {
      setErrorLabeltnc("Please enter a valid terms and conditions!");
    } else {
      setErrorLabeltnc("");
    }
  };

  const handleAdd = () => {
    if (inputtnc.trim().length === 0) {
      setErrorLabeltnc("Please enter a valid terms and conditions!");
    } else {
      if (list.includes(inputtnc.trim())) {
        setErrorLabeltnc("This Terms and Conditions already exists.");
      } else {
        setAddtnc((prev) => [...prev, inputtnc.trim()]);
        setTnc((prev) => [...prev, inputtnc.trim()]);
        setErrorLabeltnc("");
      }
      setInputtnc("");
    }
  };

  const getChildData = useCallback(
    (data, startDate, endDate, availableDate, qty) => {
      setStartDat(startDate);
      setEndDat(endDate);
      setAvailableDat(availableDate);
      setQuantity(qty);
      setDat(data);
    },
    [],
  );

  const cropBaseURLImage = (image) => {
    if (!image || typeof image !== "string") {
      return "";
    }

    if (image.startsWith("http://") || image.startsWith("https://")) {
      try {
        const urlObj = new URL(image);
        return urlObj.pathname.startsWith("/")
          ? urlObj.pathname.substring(1)
          : urlObj.pathname;
      } catch (e) {
        return image.split("/").slice(3).join("/");
      }
    }

    return image;
  };

  const handleSubmit = (e, type, status = "published") => {
    e.preventDefault();
    setCouponStatus(status);
    let flag = false;

    const plainText = stripHTML(description);
    const currentCharCount = plainText.length;
    const hasInvalidTags = /<img|<figure/i.test(description);

    if (!description) {
      setErrorLabelDesc("Please provide some description!");
      flag = true;
    } else if (hasInvalidTags && currentCharCount > max_character_count) {
      setErrorLabelDesc(
        `Character limit exceeded! You can only enter up to '${max_character_count}' characters, and images are not allowed.`,
      );
      flag = true;
    } else if (hasInvalidTags) {
      setErrorLabelDesc(ErrorMessage.ImageError);
      flag = true;
    } else if (currentCharCount > max_character_count) {
      setErrorLabelDesc(
        `Character limit exceeded! You can only enter up to ${max_character_count} characters.`,
      );
      flag = true;
    } else {
      setErrorLabelDesc("");
    }

    if (!dat.coupon_name) {
      setErrorLabelname("Please enter coupon name!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelname("");
    }

    if (!dat.coupon_code) {
      setErrorLabelcode("Please enter coupon code!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelcode("");
    }

    if (!quantity) {
      setErrorLabelquantity("Please enter total quantity!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (Number(quantity) <= 0) {
      setErrorLabelquantity("Quantity must be greater than 0!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelquantity("");
    }

    if (!startDat) {
      setErrorLabelstart("Please enter start date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelstart("");
    }

    if (!endDat) {
      setErrorLabelend("Please enter expiration date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelend("");
    }

    if (!availableDat) {
      setErrorLabelAvailableDate("Please enter available until date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelAvailableDate("");
    }

    if (tnc.length === 0) {
      setErrorLabeltnc("Please select at least one terms & condition!");
      flag = true;
    } else {
      setErrorLabeltnc("");
    }

    if (!logoImage) {
      setErrorLogoImage("Please upload coupon image!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLogoImage("");
    }

    if (flag === false) {
      const dataApi = {
        coupon_id: id,
        coupon_name: dat.coupon_name,
        coupon_code: dat.coupon_code,
        total_quantity: Number(quantity),
        business_id: uid,
        expiry_start_date: format(startDat, "yyyy-MM-dd"),
        expiry_end_date: format(endDat, "yyyy-MM-dd"),
        coupon_avail_until_date: format(availableDat, "yyyy-MM-dd"),
        description: description,
        city_id: Bu_data.city_id,
        coupon_img_change: isImageChange,
        image_path: {
          data: cropBaseURLImage(logoImage) || null,
          file_type: "png",
        },
        is_social_image: isSocialImageChange,
        coupon_social_image_path: {
          data: cropBaseURLImage(fbImage) || null,
          file_type: "png",
        },
        tnc: tnc,
        coupon_status: status,
      };

      if (type === "preview") {
        setProductModalShow(true);
      } else if (type === "save") {
        setDataApihandler(dataApi);
        setModalShow(true);
      }
    }
  };

  const handleCreate = async (data) => {
    setLoading(true);
    const res = await UpdateCouponApi(data, () => {
      navigate("/");
    });
    if (res.status === 429) {
      setLoading(false);
      toast.error(res.message, {
        position: "top-center",
        autoClose: 6000,
        theme: "dark",
      });
    } else if (res.success === true) {
      toast.success("Coupon successfully updated", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        theme: "dark",
      });
      navigate("/my-account/manage-coupons");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else {
      toast.error(res.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        theme: "dark",
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      dat?.coupon_name !== "" &&
      dat?.coupon_code !== "" &&
      quantity !== "" &&
      startDat !== null &&
      availableDat !== null &&
      endDat !== null &&
      description !== "" &&
      tnc.length > 0
    ) {
      setIsPreviewDisabled(false);
    } else {
      setIsPreviewDisabled(true);
    }
  }, [
    dat?.coupon_name,
    dat?.coupon_code,
    quantity,
    startDat,
    availableDat,
    endDat,
    description,
    tnc,
  ]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-account/manage-coupons"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Edit Coupon</p>
          <div className="acc-dashboard mt-4">
            <div className="Create-voucher_top-section">
              <CreateCouponInputs
                func={getChildData}
                initialData={dat}
                initialStartDate={startDat}
                initialEndDate={endDat}
                initialAvailableDate={availableDat}
                initialQuantity={quantity}
                errorLabelname={errorLabelname}
                errorLabelcode={errorLabelcode}
                errorLabelquantity={errorLabelquantity}
                errorLabelstart={errorLabelstart}
                errorLabelend={errorLabelend}
                errorLabelAvailableDate={errorLabelAvailableDate}
                setErrorLabelname={setErrorLabelname}
                setErrorLabelcode={setErrorLabelcode}
                setErrorLabelquantity={setErrorLabelquantity}
                setErrorLabelstart={setErrorLabelstart}
                setErrorLabelend={setErrorLabelend}
                setErrorLabelAvailableDate={setErrorLabelAvailableDate}
                // setLogoImage={setLogoImage}
                // setFbImage={setFbImage}
                logoImage={logoImage}
                fbImage={fbImage}
                errorLogoImage={errorLogoImage}
                setErrorLogoImage={setErrorLogoImage}
                setLogoImage={handleLogoImageChange}
                setFbImage={handleFbImageChange}
              />
            </div>
            <Row className="mx-2 create_Coupon_Desc_Row">
              <Col md="12" className="px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom info-sec">
                    Coupon Description <span className="star-required">*</span>{" "}
                    <p className="info-text-space-f13">
                      &#40;To start from a new line, please press Shift +
                      Enter.&#41;
                    </p>
                  </Form.Label>
                  <FroalaTextEditor
                    description={description}
                    setDescription={setDescription}
                    max_character_count={max_character_count}
                  />
                  <ErrorLabel ErrorDisplay={errorLabelDesc} />
                </Form.Group>
              </Col>
            </Row>

            {/* Terms & Conditions UI Rendering */}
            <Row className="mx-2 create_Coupon_Desc_Row">
              <Col md="12" className="px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Terms & Conditions <span className="star-required">*</span>
                    <span className="span-italic">
                      You can select terms & conditions listed below or you can
                      add more.
                    </span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Group
                      className="mb-3 ack term-sec create_Coupon_T_C"
                      controlId="formBasicCheckbox"
                    >
                      {list && list.length > 0
                        ? list.map((item, key) => {
                            return (
                              <div className="Custom-T-C-list" key={key}>
                                <label
                                  htmlFor={`tnc-${key}`}
                                  className="form-check-label"
                                  style={{ display: "flex", gap: 10 }}
                                >
                                  <input
                                    type="checkbox"
                                    id={`tnc-${key}`}
                                    className="form-check-input form-check ack"
                                    style={{ border: "1px solid #e66100" }}
                                    onChange={(e) => handleCheck(e, item)}
                                    checked={tnc.includes(item)}
                                  />
                                  {item}
                                </label>
                              </div>
                            );
                          })
                        : " "}

                      <InputGroup className="search-bar add-bar tcAdd">
                        <Form.Control
                          placeholder="Add More"
                          className="addmor"
                          maxLength={200}
                          value={inputtnc}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        <Button variant="outline-secondary" onClick={handleAdd}>
                          + Add
                        </Button>
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={errorLabeltnc} />
                    </Form.Group>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <div
                className={
                  errorLabelapi === "Coupon successfully created"
                    ? "successful pt-3"
                    : "failed pt-3"
                }
              >
                {errorLabelapi}
              </div>

              <div className="text-center gap-4 small-btns d-flex mt-4">
                <button
                  className="green-btn mt-3 update-Btn"
                  onClick={(e) => handleSubmit(e, "preview")}
                >
                  Preview
                </button>
                <Button
                  className="discard_btn"
                  variant="primary"
                  onClick={(e) => handleSubmit(e, "save", "draft")}
                >
                  Save As draft
                </Button>
              </div>

              <div className="d-flex gap-4 justify-content-center mt-4 formmain">
                <Button
                  className="discard_btn"
                  variant="secondary"
                  onClick={() => {
                    navigate("/my-account/manage-coupons");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="green-btn mt-3 update-Btn"
                  variant="primary"
                  onClick={(e) => handleSubmit(e, "save")}
                >
                  Save
                </Button>
              </div>
            </Row>
          </div>
        </div>
      </div>
      <Modals
        show={modalShow}
        onHide={() => setModalShow(false)}
        images={Warning}
        description={
          couponStatus === "draft"
            ? "Your coupon has been saved as a draft. You can edit and publish it at any time."
            : "Your coupon is almost ready! Click 'Yes' to finish creating, but remember, once created you cannot delete the coupon but can always disable it whenever you want. This will not affect the customers who might have already downloaded the coupon, they can still redeem it."
        }
        firstbutton="No"
        secondbutton="Yes"
        saveButtonfuc={handleCreate}
        Apidata={dataApihandler}
      />
      <ProductModal
        className="Modal_Popup"
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        flag="Coupon"
        product_name={dat.coupon_name}
        product_image={logoImage}
        availableDat={availableDat}
        endDat={endDat}
        description={description}
        tnc={tnc}
      />
      <PrivacyTermsConditions />
    </>
  );
};

export default EditCoupon;
